export const CSRF_COOKIE = "XSRF-TOKEN";
export const CSRF_HEADER = "X-XSRF-TOKEN";

export function readCsrfTokenFromCookie(): string | null {
  const prefix = `${CSRF_COOKIE}=`;
  const cookies = document.cookie ? document.cookie.split(";") : [];
  for (const raw of cookies) {
    const cookie = raw.trim();
    if (cookie.startsWith(prefix)) {
      return decodeURIComponent(cookie.substring(prefix.length));
    }
  }
  return null;
}

/** Cabeceras CSRF para peticiones fuera de HttpClient (p. ej. fetch). */
export function csrfHeadersForFetch(): Record<string, string> {
  const token = readCsrfTokenFromCookie();
  return token ? { [CSRF_HEADER]: token } : {};
}
